import { SearchInput } from '../../list-controls/SearchInput';
import { FilterPopover } from '../../list-controls/FilterPopover';
import { ActiveFilterChips } from '../../list-controls/ActiveFilterChips';
import { Tag } from '../../primitives/MonoLabel';
import type { FilterState } from './types';
import type { KindConfig } from './kindConfig';
import { filtersToDict, dictToFilters, buildFacetDefs } from './filterAdapter';
import type { FacetSourceOption } from './filterAdapter';

export interface AttachFilterBarProps {
  config: KindConfig; filters: FilterState; onFilters: (next: FilterState) => void;
  typeFacet: FacetSourceOption[]; ownerFacet: FacetSourceOption[]; shown: number; total: number;
}
export function AttachFilterBar({ config, filters, onFilters, typeFacet, ownerFacet, shown, total }: AttachFilterBarProps) {
  const facets = buildFacetDefs(config, typeFacet, ownerFacet);
  const dict = filtersToDict(filters);
  const onDict = (next: typeof dict) => onFilters(dictToFilters(next, filters));
  return (
    <div className="pn-attach-existing-filterbar" data-testid="attach-existing-toolbar">
      <SearchInput value={filters.q} onChange={(q) => onFilters({ ...filters, q })}
        placeholder={config.searchPlaceholder} ariaLabel={config.searchPlaceholder} testIdPrefix="attach-existing" />
      <FilterPopover filters={dict} onFiltersChange={onDict} facets={facets} testIdPrefix="attach-existing" />
      <ActiveFilterChips filters={dict} onFiltersChange={onDict} facets={facets} testIdPrefix="attach-existing" />
      <Tag data-testid="attach-existing-count">{shown} of {total}</Tag>
    </div>
  );
}
